const theme = {
  palette: {
    primary: '#6f346b',
    secondary: '#fff',
  },
};

export default theme;
